// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_EXPERIENCE_SEND = "Ode\u0161li";
export const BLOGS_ADD_NEW_COMMENT_PLACEHOLDER = "Za\u010dni ps\u00e1t koment\u00e1\u0159...";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
